import { ReactNode } from "react";
import closeIcon from '../../assets/images/icons/close-icon.svg'

type ModalProps = {
  isOpen: boolean,
  onClose: () => void
  children: ReactNode
  className?: string
}

export function Modal({ isOpen, onClose, children, className }: ModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center mx-[40px]">
      <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
      <div className={`relative bg-white z-10 rounded-[5px] ${className || ''}`}>
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          aria-label="モーダルを閉じる"
        >
          <img src={closeIcon} alt="close" />
        </button>
        {children}
      </div>
    </div>
  );
}